import axios from '@/api/config';
const homework = {
  addHomework (data) {
    return axios.post(`${process.env.BASE_URL}/homework/addHomework`, data)
  },
  getHomeworkResultByClassId (data) {
    return axios.get(`${process.env.BASE_URL}/homework/getHomeworkResultByClassId`, { params: data })
  },
  getHomeworkDetailById (data) {
    return axios.get(`${process.env.BASE_URL}/homework/getHomeworkDetailById`, { params: data })
  },
  getHomeworkExerciseById (data) {
    return axios.get(`${process.env.BASE_URL}/homework/getHomeworkExerciseById`, { params: data })
  },
  getTotalHomeworkExerciseById (data) {
    return axios.get(`${process.env.BASE_URL}/homework/getTotalHomeworkExerciseById`, { params: data })
  },
  getHomework (data) {
    return axios.get(`${process.env.BASE_URL}/homework/getHomework`, { params: data })
  },
  addHomeworkByChapterId (data) {
    return axios.post(`${process.env.BASE_URL}/homework/addHomeworkByChapterId`, data)
  },
  questionPageList (data) {
    return axios.post(`${process.env.BASE_URL}/homework/questionPageList`, data)
  },
  updateHomeworkQuestionForChapterId (data) {
    return axios.post(`${process.env.BASE_URL}/homework/updateHomeworkQuestionForChapterId`, data)
  },
  deleteHomeWorkItemByHomework (data) {
    return axios.delete(`${process.env.BASE_URL}/homework/deleteHomeWorkItemByHomework`, { data: data })
  },
  deleteHomeworkById (data) {
    return axios.delete(`${process.env.BASE_URL}/homework/deleteHomeworkById`, { data: data })
  },
  checkHomeworkExercise (data) {
    return axios.get(`${process.env.BASE_URL}/homework/checkHomeworkExercise`, { params: data })
  },
  // 导出
  exportExcel (data) {
    return axios.post(`${process.env.BASE_URL}/homework/exportExcel`, data)
  },
}
export default homework



// WEBPACK FOOTER //
// ./src/api/homework.js